import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const isLoggedIn = useSelector(s => s.platform.isLoggedIn);
  const search = window.location.search;
  return isLoggedIn ? children : <Navigate to={`/login${search}`} replace />;
};

export default PrivateRoute;
